module.exports = __webpack_public_path__ + "img/ic_64_feature_tipprunde.33150500.svg";